<template>
  <div>
    <!-- <v-snackbar
      v-model="dialogBeforeDownloadFile"
      :timeout="timeoutDownload"
      right
      @click="downloadXlsFileReal"
    >
      Файл расчётов сохранен в папке пользователя. Для того, чтобы скачать его
      нажмите ниже на кнопку.
      {{ notecalc }}
      <a target="_blank" :href="xlsFileAddress">Скачать</a>
      <v-btn
        color="pink"
        @click="(dialogBeforeDownloadFile = false), (xlsFileAddress = false)"
        >Закрыть</v-btn
      >
    </v-snackbar> -->
    <v-dialog persistent :value="dialog" width="1100">
      <v-card id="attention">
        <v-card-title class="headline grey lighten-2 pb-2" primary-title>
          <span class="centered"
            >Перед скачиванием файла можете заполнить нужные вам поля</span
          >
        </v-card-title>
        <v-form v-model="validAttention" ref="attentionWindow" lazy-validation>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="calc.lot"
                  label="№ лота"
                  mask="#########################################"
                  ref="calc_lot"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <!-- :rules="rules.purchase_number_rules" -->
                <v-text-field
                  :value="calc.purchase_number"
                  class="textInBottom"
                  label="№ закупки"
                  mask="#########################################"
                  append-icon
                  append-outer-icon="mdi-magnify"
                  @blur="OnChangePurchaseNumber"
                  @input="onPasteFromClipboardNumber($event)"
                  @click:append-outer="OnChangePurchaseNumber"
                  :disabled="loading"
                  :messages="[smpText]"
                  ref="calc_number"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="calc.dogovor_subject"
                  label="Предмет контракта (договора)"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <priceInput
                  v-model="calc.nmkc"
                  placeholder="Начальная максимальная цена контракта (договора)"
                />
                <!-- <v-text-field
                  v-model="calc.nmkc"
                  label="Начальная максимальная цена контракта (договора)"
                  dense
                  @keydown="onlyNumber($event)"
                  @change="onChangeSumm($event,'nmkc')"
                  @focus="OnTextFielsFocus($event)"
                ></v-text-field> -->
                <!-- @change="OnChangeFinValAndFormatIt($event, 'nmkc')" -->
                <!-- @keypress="OnFinSummChange($event)" -->
                <!-- @blur="OnChangeFinValAndFormatIt($event, 'nmkc')" -->
              </v-col>
              <v-col cols="12" md="6">
                <priceInput
                  v-model="calc.winprice"
                  placeholder="Предложенная цена"
                />
                <!-- <v-text-field
                  v-model="calc.winprice"
                  label="Предложенная цена"
                  dense
                  @keydown="onlyNumber($event)"
                  @change="onChangeSumm($event,'winprice')"
                  @focus="OnTextFielsFocus($event)"
                ></v-text-field> -->
                <!-- @blur="OnChangeFinValAndFormatIt($event, 'winprice')" -->
                <!-- @keypress="OnFinSummChange($event)" -->
                <!-- @change="OnChangeFinValAndFormatIt($event, 'winprice')" -->
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="calc.date3"
                  label="Дата исполнения контракта (договора)"
                  persistent-hint
                  v-mask="rules.dateMask"
                  @focus="OnTextFielsFocus($event)"
                  @change="
                    setPickerToNewDateUniversal('date3', 'dateConverted3')
                  "
                >
                  <template v-slot:append-outer>
                    <v-menu
                      ref="menu3"
                      v-model="menu3"
                      :close-on-content-click="true"
                      transition="scale-transition"
                      left
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon left v-on="on">event</v-icon>
                      </template>
                      <v-date-picker
                        first-day-of-week="1"
                        v-model="calc.dateConverted3"
                        no-title
                        @input="
                          InputDataPickerUniversal(
                            'date3',
                            'dateConverted3',
                            'menu3'
                          )
                        "
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="calc.date4"
                  label="Дата окончания действия контракта (договора)"
                  persistent-hint
                  v-mask="rules.dateMask"
                  @focus="OnTextFielsFocus($event)"
                  @change="
                    setPickerToNewDateUniversal('date4', 'dateConverted4')
                  "
                >
                  <template v-slot:append-outer>
                    <v-menu
                      ref="menu4"
                      v-model="menu4"
                      :close-on-content-click="true"
                      transition="scale-transition"
                      left
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon left v-on="on">event</v-icon>
                      </template>
                      <v-date-picker
                        first-day-of-week="1"
                        v-model="calc.dateConverted4"
                        no-title
                        @input="
                          InputDataPickerUniversal(
                            'date4',
                            'dateConverted4',
                            'menu4'
                          )
                        "
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <template v-if="!calc.itogs">
                  <v-text-field
                    v-model="calc.date5"
                    label="Дата итогового протокола"
                    persistent-hint
                    v-mask="rules.dateMask"
                    @focus="OnTextFielsFocus($event)"
                    @change="
                      setPickerToNewDateUniversal('date5', 'dateConverted5')
                    "
                  >
                    <template v-slot:append-outer>
                      <v-menu
                        ref="menu5"
                        v-model="menu5"
                        :close-on-content-click="true"
                        transition="scale-transition"
                        left
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon left v-on="on">event</v-icon>
                        </template>
                        <v-date-picker
                          first-day-of-week="1"
                          v-model="calc.dateConverted5"
                          no-title
                          @input="
                            InputDataPickerUniversal(
                              'date5',
                              'dateConverted5',
                              'menu5'
                            )
                          "
                        ></v-date-picker>
                      </v-menu>
                    </template>
                  </v-text-field>
                </template>
                <template v-else-if="calc.itogs">
                  <v-menu
                    ref="menu5"
                    v-model="menu5"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        disabled
                        v-model="calc.date5"
                        label="Дата итогового протокола"
                        persistent-hint
                        v-mask="rules.dateMask"
                        v-on="on"
                        @focus="OnTextFielsFocus($event)"
                        @change="
                          setPickerToNewDateUniversal('date5', 'dateConverted5')
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      first-day-of-week="1"
                      v-model="calc.dateConverted5"
                      no-title
                      @input="
                        InputDataPickerUniversal(
                          'date5',
                          'dateConverted5',
                          'menu5'
                        )
                      "
                    ></v-date-picker>
                  </v-menu>
                </template>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" md="4" offset-md="8">
                <v-checkbox
                  class="p-0 m-0"
                  dense
                  right
                  v-model="calc.itogs"
                  label="Победитель еще не определён"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="calc.customer_inn"
                  label="ИНН заказчика"
                  dense
                  counter="12"
                  v-mask="'############'"
                  append-outer-icon="mdi-magnify"
                  @click:append-outer="OnChangeCustomerINNLupa()"
                  @change="OnChangeCustomerINNLupa()"
                  @input="onPasteFromClipboard"
                  :disabled="loading"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  v-model="calc.client_inn"
                  label="ИНН победителя"
                  counter="12"
                  v-mask="'############'"
                  append-outer-icon="mdi-magnify"
                  @change="OnChangePurchaseINNLupa()"
                  @input="onPasteFromClipboard"
                  @click:append-outer="OnChangePurchaseINNLupa()"
                  :disabled="loading"
                  ref="calc_inn"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-textarea
                  v-model="calc.customer"
                  label="Наименование заказчика"
                  dense
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  v-model="calc.client_name"
                  label="Наименование победителя"
                  auto-grow
                  rows="1"
                  dense
                ></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  v-model="calc.customer_adres"
                  label="Адрес заказчика"
                  dense
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  v-model="calc.client_address"
                  label="Адрес победителя"
                  auto-grow
                  dense
                  rows="1"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  dense
                  v-model="calc.customer_kpp"
                  label="КПП заказчика"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  v-model="calc.customer_ogrn"
                  label="ОГРН заказчика"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  v-model="calc.client_kpp"
                  label="КПП победителя"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  v-model="calc.client_ogrn"
                  label="ОГРН победителя"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field
              dense
              v-model="calc.note"
              label="Примечание"
            ></v-text-field>
          </v-card-text>
        </v-form>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="CloseDialog">Отмена</v-btn>
          <v-btn
            :disabled="!validData"
            color="#217899"
            @click="downloadExcelSelected"
            text
            >Скачать</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Globalrules from "../../components/api/rules";
import { getReportUrl } from "../../components/api/localglobal";
import Swal from "sweetalert2";
import { isEmptyObject } from "@/plugins/isEmptyObject";
import priceInput from "@/components/priceInput";

export default {
  props: ["msg", "vid"],
  components: { priceInput },
  data: () => ({
    note: "",
    loading: false,
    menu3: false,
    menu4: false,
    menu5: false,
    timeoutDownload: 0,
    xlsFileAddress: null,
    validAttention: "",
    attentionWindow: "",
    validData: true,
    dialogBeforeDownloadFile: false,
    rules: Globalrules,
  }),
  methods: {
    InputDataPickerUniversal(dateparam, calendarparam, menu) {
      this[menu] = false;
      this.$store.dispatch("SET_CALC_PARAM", {
        param: dateparam,
        value: this.calendarToDate(this.$store.getters.calc[calendarparam]),
      });
    },
    clearAllInNumberLupa() {
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_address",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_inn",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_kpp",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_name",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_ogrn",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", { param: "customer", value: "" });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "customer_adres",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "customer_inn",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "customer_kpp",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "customer_ogrn",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "decrision_of_price",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "dogovor_subject",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", { param: "date3", value: "" });
      this.$store.dispatch("SET_CALC_PARAM", { param: "date4", value: "" });
      this.$store.dispatch("SET_CALC_PARAM", { param: "date5", value: "" });
      this.$store.dispatch("SET_CALC_PARAM", { param: "nmkc", value: "" });
    },
    clearClientLupa() {
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_address",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_kpp",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_name",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_ogrn",
        value: "",
      });
    },
    clearCustomerLupa() {
      this.$store.dispatch("SET_CALC_PARAM", { param: "customer", value: "" });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "customer_adres",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "customer_kpp",
        value: "",
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "customer_ogrn",
        value: "",
      });
    },
    fillColumns() {
      Swal.fire({
        icon: "warning",
        title: "",
        text:
          "Не все поля формы были заполнены автоматически. Вы можете заполнить их вручную",
      });
    },

    setPickerToNewDateUniversal(dateparam, calendarparam) {
      this.$store.dispatch("SET_CALC_PARAM", {
        param: dateparam,
        value: this.getNormalizeDate(dateparam, "ru"),
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: calendarparam,
        value: this.dateToCalendar(this.$store.getters.calc[dateparam]),
      });
      this.saveReportData(false);
    },

    onPasteFromClipboard() {
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_inn",
        value: String(this.$store.getters.calc.client_inn).replace(
          /(\r\n|\n|\r|\s|\s+)/g,
          ""
        ),
      });
    },
    onPasteFromClipboardNumber(data) {
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "purchase_number",
        value: data.trim().replace(/(\r\n|\n|\r)/g, ""),
      });
    },
    generateExcell(selectedTable = false) {
      const table = selectedTable ? this.DeepCopy(this.getSelectedTable()) : this.DeepCopy(this.getAllTable())
      table.map(item=>item.bank_logo = '')
      const data = {
        table,
        client_inn: this.correctStr(this.$store.getters.calc.client_inn),
        client_address: this.correctStr(
          this.$store.getters.calc.client_address
        ),
        client_name: this.correctStr(this.$store.getters.calc.client_name),
        client_kpp: this.correctStr(this.$store.getters.calc.client_kpp),
        client_ogrn: this.correctStr(this.$store.getters.calc.client_ogrn),
        purchase_number: this.correctStr(
          this.$store.getters.calc.purchase_number
        ),
        lot_number: this.correctStr(this.$store.getters.calc.lot),
        customer: this.correctStr(this.$store.getters.calc.customer),
        customer_inn: this.correctStr(this.$store.getters.calc.customer_inn),
        customer_kpp: this.correctStr(this.$store.getters.calc.customer_kpp),
        customer_ogrn: this.correctStr(this.$store.getters.calc.customer_ogrn),
        customer_adres: this.correctStr(
          this.$store.getters.calc.customer_adres
        ),
        dogovor_subject: this.correctStr(
          this.$store.getters.calc.dogovor_subject
        ),
        nmkc: this.correctNum(this.$store.getters.calc.nmkc),
        price_predlog: this.correctStr(this.$store.getters.calc.winprice),
        decrision_of_price: this.correctNum(
          this.$store.getters.calc.decrision_of_price
        ),
        date_isp_dog: this.correctStr(this.$store.getters.calc.date3),
        date_finish_dogovor: this.correctStr(this.$store.getters.calc.date4),
        date_final_protocol: this.correctStr(this.$store.getters.calc.date5),
        summ: this.correctNum(this.$store.getters.calc.summ),
        date_from: this.correctStr(this.$store.getters.calc.date),
        date_to: this.correctStr(this.$store.getters.calc.date2),
        days: this.$store.getters.calc.days,
        purchase: this.correctStr(this.$store.getters.calc.purchasesVal),
        quarantee: this.correctStr(this.$store.getters.calc.quaranteesVal),
        bs: this.correctStr(this.$store.getters.calc.isBS),
        avans: this.correctStr(this.$store.getters.calc.isAvans),
        gar_form_zak: this.correctStr(this.$store.getters.calc.isGarFormZak),
        original_paper: this.correctStr(this.$store.getters.calc.isPaper),
        gar_polz_zak: this.getGarPolzZakActual(),
        situation: this.getClientSituation(),
        agent_fio: `${this.$store.getters.profile.name} ${this.$store.getters.profile.famil}`,
        agent_position: `специалист по госзакупкам`,
        agent_email: this.$store.getters.profile.emailContact,
        agent_phone: `тел.: ${this.$store.getters.profile.phone}`,
        session: this.session,
        action: "generate",
        note: this.$store.getters.calc.note,
        smp: this.$store.getters.calc.smp,
        itogs: this.correctNum(this.$store.getters.calc.itogs),
      };
      this.$store
        .dispatch("generateExcell", data)
        .then((response) => {
          //
          this.fileDownload(`${getReportUrl()}reports/${response.data.name}`)

          //
          //
          // this.xlsFileAddress = response.config.baseURL + "/storage/" + response.data;
          // this.dialogBeforeDownloadFile = true;
          this.validData = true;

          this.$store.dispatch("setAttentionDIalog", false);

          // .then(() => {})
          // .catch(error => {
          //   this.$router.push("/logout");
          //   Swal.fire({
          //     icon: "error",
          //     title: "Сеанс пользователя завершен. ",
          //     text:
          //       "Время Вашей сессии истекло, для продолжения работы войдите в личный кабинет заново"
          //   });
          // });

          //  Swal.fire({
          //    icon: "success",
          //    title: "Файл успешно создан",
          //    text: "Ссылка на скачку файла: "+this.$http.options.root + "/" + response.data
          //  });
        })
        .catch(() => {
          this.validData = true;
          Swal.fire({
            icon: "error",
            title: "Ошибка",
            text:
              "Сервер отчетов не отвечает! \n Пожалуйста, свяжитесь со своим менеджером по работе с клиентами.",
          });
        });
    },
    downloadExcelSelected() {
      // if (!session) {
      //   Swal.fire({
      //     icon: "warning",
      //     title: "Внимание!",
      //     text:
      //       "Расчет нельзя скачать, если вы нажимали на кнопки Назад или Вперед на панели браузера",
      //   });
      //   return;
      // }

      // if (
      //   this.$store.getters.calc.lot === "" ||
      //   this.$store.getters.calc.lot.length < 1
      // ) {
      //   Swal.fire({
      //     icon: "warning",
      //     title: "Внимание!",
      //     text: "Проверьте указанн ли Лот.",
      //   });
      //   return;
      // }

      // if (!this.$store.getters.calc.itogs) {
      //   if (
      //     !this.$store.getters.calc.client_inn ||
      //     this.$store.getters.calc.client_inn.length < 10 ||
      //     this.$store.getters.calc.client_inn.length > 12 ||
      //     this.$store.getters.calc.client_inn.length == 11
      //   ) {
      //     Swal.fire({
      //       icon: "warning",
      //       title: "Внимание!",
      //       text:
      //         'Проверьте указанный ИНН. Он должен состоять из 10 или 12 цифр. Или выберите "Победитель ещё не определён".',
      //     });
      //     return;
      //   }
      // }

      // if (this.$store.getters.calc.purchase_number.length < 3) {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Введенный номер закупки слишком короткий",
      //     text:
      //       "Укажите нормальный номер закупки. У вас его длина равна " +
      //       this.$store.getters.calc.purchase_number.length,
      //   });
      //   return;
      // }

      // if (this.vid == 3) return;
      // if (this.$refs.attentionWindow.validate()) {
      //   //
      // } else {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Ошибка заполнения полей",
      //     text: "Заполните обязательные поля",
      //   });
      //   return;
      // }
      // this.validData = false;
      this.saveReportData(true);
      this.generateExcell(true);
    },
    downloadExcelAll() {
      // if (!this.session) {
      //   Swal.fire({
      //     icon: "warning",
      //     title: "Внимание!",
      //     text:
      //       "Расчет нельзя скачать, если вы нажимали на кнопки Назад или Вперед на панели браузера",
      //   });
      //   return;
      // }
      // if (this.$refs.attentionWindow.validate()) {
      //   //
      // } else {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Ошибка заполнения полей",
      //     text: "Заполните обязательные поля",
      //   });
      //   return;
      // }
      // this.validData = false;
      this.saveReportData(false);
      this.generateExcell(false);
    },
    OnChangeFinValAndFormatIt(evt, param) {
      if (evt.target.value !== undefined) {

        const val =
          Number(evt.target.value) !== "NaN"
            ? Number(evt.target.value)
            : Number(evt.target.value.replace(",", "."));
        this.$store.dispatch("SET_CALC_PARAM", {
          param,
          value: Number(evt.target.value)
            .toFixed(2)
            .toLocaleString("ru")
            .replace(".", ","),
        });
      }
    },

    getQuaranteesById() {
      const quarantee = this.$store.getters.getQuaranteesById(
        this.$store.getters.calc.quaranteesVal
      );
      if (quarantee.length) {
        return quarantee[0].name;
      } else {
        return "-";
      }
    },

    getGarPolzZak() {
      const gar_polz_zak = this.$store.getters.calc.gar_polz_zaksVal;
      if (!gar_polz_zak) return "-";
      return gar_polz_zak.name;
    },

    OnChangePurchaseNumber() {
      this.clearAllInNumberLupa();
      if (this.$store.getters.calc.purchase_number === undefined) {
        //
        return;
      } else if (this.$store.getters.calc.purchase_number !== "") {
        this.loading = true;

        this.$store
          .dispatch("PROTOCOL_INFO_BY_NUMBER", this.$store.getters.calc)
          .then((res) => {

            if (res.message !== undefined) {
              this.loading = false;
              Swal.fire({
                icon: "warning",
                title: "Внимание",
                text: "Такой протокол не найден!",
              });
            } else {
              this.fillColumns();
              const data = res;

              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_address",
                value:
                  data.egrul && data.egrul.address ? data.egrul.address : "",
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_name",
                value:
                  data.egrul && data.egrul.fullname
                    ? data.egrul.fullname
                    : data.winner_name
                    ? data.winner_name
                    : "",
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_inn",
                value:
                  data.egrul && data.egrul.inn
                    ? data.egrul.inn
                    : data.winner_inn
                    ? data.winner_inn
                    : "",
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_kpp",
                value:
                  data.egrul && data.egrul.kpp
                    ? data.egrul.kpp
                    : data.winner_kpp
                    ? data.winner_kpp
                    : "",
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_ogrn",
                value:
                  data.egrul && data.egrul.ogrn
                    ? data.egrul.ogrn
                    : data.winner_ogrn
                    ? data.winner_ogrn
                    : "",
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "dogovor_subject",
                value: data.name
                  ? data.name
                  : data.purchaseObjectInfo
                  ? data.purchaseObjectInfo
                  : "",
              });
              if (data.purchase) {
                //Отключение обновления суммы при поиске по протоколу
                // this.$store.dispatch("SET_CALC_PARAM", {
                //   param: "bg",
                //   value:
                //     data.purchase && data.purchase.guarantee
                //       ? data.purchase.guarantee
                //       : null,
                // });
                // this.$store.dispatch("SET_CALC_PARAM", {
                //   param: "nmkc",
                //   value:
                //     data.purchase && typeof data.purchase.maxprice === "string"
                //       ? this.removeCommas(data.purchase.maxprice)
                //       : Number(data.purchase.maxprice),
                // });
                // this.$store.dispatch('SET_CALC_PARAM',{param: 'data' ,value: data.data})
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer",
                  value:
                    data &&
                    data.purchase &&
                    data.purchase.customer &&
                    data.purchase.customer.fullName
                      ? data.purchase.customer.fullName
                      : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer_inn",
                  value:
                    data.purchase &&
                    data.purchase.customer &&
                    data.purchase.customer.inn
                      ? data.purchase.customer.inn
                      : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer_kpp",
                  value:
                    data.purchase &&
                    data.purchase.customer &&
                    data.purchase.customer.kpp
                      ? data.purchase.customer.kpp
                      : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer_adres",
                  value:
                    data.purchase &&
                    data.purchase.customer &&
                    data.purchase.customer.address
                      ? data.purchase.customer.address
                      : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer_ogrn",
                  value:
                    data.purchase &&
                    data.purchase.customer &&
                    data.purchase.customer.ogrn
                      ? data.purchase.customer.ogrn
                      : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "date3",
                  value:
                    data.purchase && data.purchase.deliveryDate
                      ? this.getNormalizeDate(data.purchase.deliveryDate, "ru")
                      : "",
                }); // Дата исполнение контракта
              } else {
                //Отключение обновления суммы при поиске по протоколу
                // this.$store.dispatch("SET_CALC_PARAM", {
                //   param: "bg",
                //   value: data.guarantee ? data.guarantee : null,
                // });
                // this.$store.dispatch("SET_CALC_PARAM", {
                //   param: "nmkc",
                //   value: data.maxprice
                //     ? typeof data.maxprice === "string"
                //       ? this.removeCommas(data.maxprice)
                //       : Number(data.maxprice)
                //     : "",
                // });
                // this.$store.dispatch('SET_CALC_PARAM',{param: 'data' ,value: data.data})
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer",
                  value: data.customer ? data.customer.fullName : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer_inn",
                  value:
                    data.customer && data.customer.inn ? data.customer.inn : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer_kpp",
                  value:
                    data.customer && data.customer.kpp ? data.customer.kpp : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer_adres",
                  value:
                    data.customer && data.customer.address
                      ? data.customer.address
                      : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "customer_ogrn",
                  value:
                    data.customer && data.customer.ogrn
                      ? data.customer.ogrn
                      : "",
                });
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "date3",
                  value: data.deliveryDate
                    ? this.getNormalizeDate(data.deliveryDate, "ru")
                    : "",
                }); // Дата исполнение контракта
              }
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "date4",
                value:
                  data.contractTerm && data.contractTerm.date
                    ? this.getNormalizeDate(data.contractTerm.date, "ru")
                    : "",
              }); // Дата окончания действия контракта
              if ((data.egrul && data.egrul.inn) || data.winner_inn) {
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "itogs",
                  value: false,
                });
              } else {
                this.$store.dispatch("SET_CALC_PARAM", {
                  param: "itogs",
                  value: true,
                });
              }

              // this.$store.dispatch('SET_CALC_PARAM',{param: 'date5', value: moment(data.data).format("DD.MM.YYYY")})
              this.saveReportData(false);
              this.loading = false;
            }
          })
          .catch((error) => {
            alert(error);
            this.loading = false;
            Swal.fire({
              icon: "error",
              title: "Ошибка сервера",
              text: "Что то пошло не так! Попробуйте позже. Сервер недоступен!",
            });
          });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Пустой номер протокола",
          text: "",
        });
      }
    },

    OnChangePurchaseINNLupa() {
      this.clearClientLupa(); // clear All client fields

      if (this.$store.getters.calc.client_inn !== "") {
        this.loading = true;
        this.$store
          .dispatch("FillByINN", { inn: this.$store.getters.calc.client_inn })
          .then((res) => {
            if (res.status_api === "gosebase") {
              const data = res.data.main.data;
              if (
                isEmptyObject(data.name) ||
                isEmptyObject(data.address) ||
                isEmptyObject(data.kpp) ||
                isEmptyObject(data.ogrn)
              ) {
                this.fillColumns();
              }

              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_name",
                value: data.name.full_with_opf,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_address",
                value: data.address.unrestricted_value,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_kpp",
                value: data.kpp,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_ogrn",
                value: data.ogrn,
              });
            } else if (res.status_api === "dadata") {
              const data = res.data[0];
              if (
                isEmptyObject(data.name) ||
                isEmptyObject(data.address) ||
                isEmptyObject(data.kpp) ||
                isEmptyObject(data.ogrn)
              ) {
                this.fillColumns();
              }
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_name",
                value: data.name,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_address",
                value: data.address,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_kpp",
                value: data.kpp,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "client_ogrn",
                value: data.ogrn,
              });
            }
            this.saveReportData(false);
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            // this.$router.push("/logout");
            Swal.fire({
              icon: "error",
              title: "Что то пошло не так!",
              text: "Мы не нашли такой ИНН",
            });
          });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Нет данных по ИНН",
          text: "",
        });
      }
    },

    OnChangeCustomerINNLupa() {
      this.clearCustomerLupa(); // clear all custumer fields
      if (this.$store.getters.calc.customer_inn !== "") {
        this.loading = true;
        this.$store
          .dispatch("FillByINN", { inn: this.$store.getters.calc.customer_inn })
          .then((res) => {
            if (res.status_api === "gosebase") {
              const data = res.data.main.data;
              if (
                isEmptyObject(data.name) ||
                isEmptyObject(data.address) ||
                isEmptyObject(data.kpp) ||
                isEmptyObject(data.ogrn)
              ) {
                this.fillColumns();
              }

              this.$store.dispatch("SET_CALC_PARAM", {
                param: "customer",
                value: data.name.full_with_opf,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "customer_adres",
                value: data.address.unrestricted_value,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "customer_kpp",
                value: data.kpp,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "customer_ogrn",
                value: data.ogrn,
              });
            } else if (res.status_api === "dadata") {
              const data = res.data[0];
              if (
                isEmptyObject(data.name) ||
                isEmptyObject(data.address) ||
                isEmptyObject(data.kpp) ||
                isEmptyObject(data.ogrn)
              ) {
                this.fillColumns();
              }
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "customer",
                value: data.name,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "customer_adres",
                value: data.address,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "customer_kpp",
                value: data.kpp,
              });
              this.$store.dispatch("SET_CALC_PARAM", {
                param: "customer_ogrn",
                value: data.ogrn,
              });
            }
            this.saveReportData(false);
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            Swal.fire({
              icon: "error",
              title: "Что то пошло не так!",
              text: "Мы не нашли такой ИНН",
            });
          });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Нет данных по ИНН",
          text: "",
        });
      }
    },

    CloseDialog() {
      this.validData = true;
      this.loading = false;

      //this.$refs.attentionWindow.reset();

      this.$store.dispatch("setAttentionDIalog", false).then(() => {});
    },
  },

  computed: {
    smpText() {
      if (this.$store.getters.calc.smp) {
        if (
          this.$store.getters.calc.purchasesVal === 1 &&
          this.$store.getters.calc.quaranteesVal === 1
        ) {
          return "Закупка для СМП, проверьте сумму гарантии - должна рассчитываться от ПРЕДЛОЖЕННОЙ победителем цены контракта";
        } else return "";
      } else return "";
    },
    notecalc() {
      return this.note;
    },
    dialog() {
      return this.$store.getters.getAttentionDialog;
    },
    calc() {
      return this.$store.getters.calc;
    },
    selected1: {
      get() {
        return this.$store.getters.get_selected1;
      },
      set(val) {
        this.$store.dispatch("SET_SELECTED1", val);
      },
    },
    selected2: {
      get() {
        return this.$store.getters.get_selected2;
      },
      set(val) {
        this.$store.dispatch("SET_SELECTED2", val);
      },
    },
  },
};
</script>

<style lang="scss">
#attention {
  .textInBottom {
    .v-text-field__details {
      display: inline;
      .theme--light.v-messages {
        height: auto;
        .v-messages__message {
          margin-top: 4px;
          color: red;
        }
      }
    }
  }

  .centered {
    text-align: center;
    margin: auto;
    display: block;
    float: none;
    color: #217899;
  }
  .centeredintro {
    text-align: center;
  }
  .col,
  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col-auto,
  .col-lg,
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-auto,
  .col-md,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-auto,
  .col-sm,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-auto,
  .col-xl,
  .col-xl-1,
  .col-xl-2,
  .col-xl-3,
  .col-xl-4,
  .col-xl-5,
  .col-xl-6,
  .col-xl-7,
  .col-xl-8,
  .col-xl-9,
  .col-xl-10,
  .col-xl-11,
  .col-xl-12,
  .col-xl-auto {
    padding-bottom: 0;
  }
  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
  .v-messages {
    min-height: 0;
  }
  .v-text-field__details {
    min-height: 0;
  }
  .v-card__actions > .v-btn.v-btn {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .v-card__actions {
    padding-top: 0;
    padding-bottom: 0;
  }
}
.v-input input:-internal-autofill-selected {
  background-color: transparent !important;
}
#app {
  .v-tooltip__content {
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
